import { InputSwitch } from 'primereact/inputswitch'
import { RadioButton } from 'primereact/radiobutton'
import { Slider } from 'primereact/slider'
import * as myconst from "../../constants/index"
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { InputTextarea } from 'primereact/inputtextarea'

interface arr_type {
  value: string;
  label: string;
}

const StepFive = ({ handlePrev, handleNext, goOnFirst, isLinear, goOnLast, methods, setErrorSteps }: any) => {
  const { register, getValues, setValue, watch, formState: { errors }, control, trigger, clearErrors } = useFormContext();
  const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
  const textValue = watch('time_commitment');
  const budget = watch('budget');
  const handleChange = (event: any, maxValue: number) => {
    // if (maxValue === 2) {
    //   // setTextValue("With each increase in the threshold, Source Info's output will become less accurate, resulting in fewer relevant documents being retrieved.")
    //   setRangeValue(event.target.value); // Update rangeValue state when slider value changes
    // } else if (event.target.value < rangeValue && maxValue === 2) {
    //   // setTextValue("By lowering the threshold, Source Info's output will become more accurate, resulting in more relevant documents being retrieved.")
    //   setRangeValue(event.target.value); // Update rangeValue state when slider value changes
    // }
    updateTooltipPosition(event, maxValue); // Update tooltip position
  };
  const finalError = Object.keys(errors).length
  useEffect(() => {
    setErrorSteps(Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).filter((item, index) => Object.keys(errors).map((keys: string) => (myconst.findStepWhichAreIncomplete(keys))).indexOf(item) === index))
  }, [finalError])

  const updateTooltipPosition = (event: any, maxValue: number) => {
    const sliderWidth = event.target.offsetWidth;
    const sliderValue = parseFloat(event.target.value);
    const thumbWidth = 14; // Adjust according to your slider thumb size
    const tooltipWidth = 40; // Adjust according to your tooltip width
    const offsetLeft = ((sliderValue / maxValue) * (sliderWidth - thumbWidth) + (thumbWidth / 2) - (tooltipWidth / 2)) + 20;
    const offsetTop = -30; // Adjust top position as needed
    setTooltipPosition({ left: offsetLeft, top: offsetTop });
  };

  const getFormErrorMessage = (name: string) => {
    return (
      errors[name] && (
        <small className="p-error">{errors[name]?.message?.toString()}</small>
      )
    )
  }

  const handleNextButton = async () => {
    let isValid: boolean = false;
    isValid = await trigger(['budget', 'learning_willingness']);

    if (isValid) {
      handleNext();
    } else {
      const errorFields = Object.keys(errors);
      if (errorFields.length > 0) {
        const errorField = errorFields[0];
        const fieldElement = document.querySelector(`input[name=${errorField}]`);
        if (fieldElement) {
          (fieldElement as HTMLElement)?.focus();
        } else {
          console.warn(`Field with name ${errorField} not found`);
        }
      }
    }
  }

  return (
    <div className='step-preview-wrap'>
      <div className='stepper-main_butter_pie'>
        <div className='stepper-form'>
          <div className='stepper-wrapper'>
            <div className="form-row">
              <div className="form-col d-flex justify-content-between w-full">
                <label className="form-label fw-bold">How much time per week can you dedicate to content creation?</label>
                <span className="fw-bold">{textValue} hours</span>
              </div>
              <div className="form-col">
                <Controller
                  name={'time_commitment'}
                  control={methods.control}
                  render={({ field: { onBlur, onChange, value } }) => (
                    <div className="w-full">
                      <div className="range-slider-container">
                        <div className="d-flex flex-column">
                          <span>
                            <input
                              type="range"
                              className="w-full"
                              min={1} // Minimum value
                              max={40} // Maximum value
                              value={value} // Current value
                              onChange={(e) => { handleChange(e, 40); onChange(e.target.value) }} // Handle change event
                              onMouseOver={(e) => { updateTooltipPosition(e, 40); }}
                              onMouseOut={() => setTooltipPosition({ left: 0, top: 0 })}
                              step={1}
                            />
                            {/* Tooltip to display current value */}
                            {/* {(value || value === 0) && tooltipPosition.top !== 0 && tooltipPosition.left !== 0 &&
                              <span className="tooltip" style={{ left: tooltipPosition.left }}>
                                {value}
                              </span>
                            } */}
                          </span>
                          <div className="d-flex justify-content-between">
                            <span>1 hours</span>
                            <span>40 hours</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-col d-flex justify-content-between w-full">
                <label className="form-label fw-bold">Do you have a budget for equipment, editing, or promotion?</label>
                <span className="fw-bold">${budget}</span>

                {/* <InputTextarea style={{ fontSize: "14px" }} rows={6} className="form-control p-inputtext-lg" {...register("budget", { required: { value: true, message: "Budget is required" } })} placeholder="Add your budget here..." />
                {getFormErrorMessage("budget")} */}
              </div>
              <div className="form-col">
                <Controller
                  name={'budget'}
                  control={methods.control}
                  render={({ field: { onBlur, onChange, value } }) => (
                    <div className="w-full">
                      <div className="range-slider-container">
                        <div className="d-flex flex-column">
                          <span>
                            <input
                              type="range"
                              className="w-full"
                              min={0} // Minimum value
                              max={2000} // Maximum value
                              value={value} // Current value
                              onChange={(e) => { onChange(e.target.value) }} // Handle change event
                              // onMouseOver={(e) => { updateTooltipPosition(e, 40); }}
                              // onMouseOut={() => setTooltipPosition({ left: 0, top: 0 })}
                              step={100}
                            />
                            {/* Tooltip to display current value */}
                            {(value || value === 0) && tooltipPosition.top !== 0 && tooltipPosition.left !== 0 &&
                              <span className="tooltip" style={{ left: tooltipPosition.left }}>
                                {value}
                              </span>
                            }
                          </span>
                          <div className="d-flex justify-content-between">
                            <span>$0</span>
                            <span>$2000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <label className="form-label fw-bold">Are you willing to learn new tools or hire help if needed?</label>
                <Controller
                  name="learning_willingness"
                  control={methods.control}
                  rules={{ required: "Please select a category" }}
                  render={({ field }) => (
                    <>
                      {myconst.getRadioOptions('learning_willingness').map((option: arr_type) => (
                        <div
                          key={option.value}
                          className="p-field-radiobutton"
                        >
                          <RadioButton
                            inputId={option.value}
                            value={option.value}
                            onChange={(e) => { field.onChange(e.value); clearErrors('learning_willingness') }}
                            checked={field.value === option.value}
                          />
                          <label className="ms-2 c-pointer" onClick={() => { field.onChange(option.value); clearErrors('learning_willingness') }} htmlFor={option.value}>{option.label}</label>
                        </div>
                      ))}
                    </>
                  )}
                />
                {getFormErrorMessage("learning_willingness")}
              </div>
            </div>
          </div>
        </div>
        <div className='stepper-footer'>
          <div className='stepper-wrapper stepper-wrapper-ft ms-auto'>
            <div className='stepper-footer-inner'>
              <div className='stepper-footer-left'>
                <button type="button" onClick={goOnFirst} className="grey-outline-btn mr-2">{'<< First'}</button>
                <button type="button" onClick={handlePrev} className="outline-active-btn">{'< Previous'}</button>
              </div>
              <div className='stepper-footer-right'>
                <button type="button" className="outline-active-btn mr-2" onClick={handleNextButton}>{'Next >'}</button>
                <button type="button" disabled={!isLinear} className="grey-outline-btn" onClick={goOnLast}>{'Last >>'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepFive